import { call, takeLatest } from "redux-saga/effects";
import * as logsApis from "../apis/logsApis";
import { SYSTEM_LOGS_LIST } from "../actions/types";

export function* logsListWorker(action) {
    try {
        const res = yield call(logsApis.logsListApi, action.data);
        if (res.status === 200) {
            yield action.onSuccess(res);
        } else {
            yield action.onError(res);
        }
    } catch (error) {
        yield action.onError({
            data: {
                message: error,
            },
        });
    }
}

export function* logsListWatcher() {
    yield takeLatest(SYSTEM_LOGS_LIST, logsListWorker);
}
